module.exports = __webpack_public_path__ + "img/police_station_pinpoint.979fc4d1.svg";